export const FETCH_DISCIPLINARY = "FETCH_DISCIPLINARY";
export const FETCH_LOCATION_DISCIPLINARY = "FETCH_LOCATION_DISCIPLINARY";
export const FETCH_LOCATION_DISCIPLINARY_SUCCESS =
  "FETCH_LOCATION_DISCIPLINARY_SUCCESS";
export const FETCH_LOCATION_DISCIPLINARY_FAILURE =
  "FETCH_LOCATION_DISCIPLINARY_FAILURE";
export const FETCH_DISCIPLINARY_SUCCESS = "FETCH_DISCIPLINARY_SUCCESS";
export const FETCH_DISCIPLINARY_FAILURE = "FETCH_DISCIPLINARY_FAILURE";

export const FETCH_DISCIPLINARY_RECORD = "FETCH_DISCIPLINARY_RECORD";
export const FETCH_DISCIPLINARY_RECORD_SUCCESS =
  "FETCH_DISCIPLINARY_RECORD_SUCCESS";
export const FETCH_DISCIPLINARY_RECORD_FAILURE =
  "FETCH_DISCIPLINARY_RECORD_FAILURE";

export const SAVE_DISCIPLINARY = "SAVE_DISCIPLINARY";
export const SAVE_DISCIPLINARY_SUCCESS = "SAVE_DISCIPLINARY_SUCCESS";
export const SAVE_DISCIPLINARY_FAILURE = "SAVE_DISCIPLINARY_FAILURE";

export const POST_DISCIPLINARY_ACTION = "POST_DISCIPLINARY_ACTION";
export const POST_DISCIPLINARY_ACTION_SUCCESS =
  "POST_DISCIPLINARY_ACTION_SUCCESS";
export const POST_DISCIPLINARY_ACTION_FAILURE =
  "POST_DISCIPLINARY_ACTION_FAILURE";

export const CLEAR_DISCIPLINARY_MESSAGE = "CLEAR_DISCIPLINARY_MESSAGE";

export const DELETE_DISCIPLINARY = "DELETE_DISCIPLINARY";
export const DELETE_DISCIPLINARY_SUCCESS = "DELETE_DISCIPLINARY_SUCCESS";
export const DELETE_DISCIPLINARY_FAILURE = "DELETE_DISCIPLINARY_FAILURE";

export const UPLOAD_DISCIPLINARY_ATTACHMENT = "UPLOAD_DISCIPLINARY_ATTACHMENT";
export const UPLOAD_DISCIPLINARY_ATTACHMENT_SUCCESS =
  "UPLOAD_DISCIPLINARY_ATTACHMENT_SUCCESS";
export const UPLOAD_DISCIPLINARY_ATTACHMENT_FAILURE =
  "UPLOAD_DISCIPLINARY_ATTACHMENT_FAILURE";
